import React from 'react';
import Footer from '../components/Footer';

const FooterLayout = ({ children }) => {
  return (
    <>
      {children}
      <Footer />
    </>
  );
};

export default FooterLayout;
